import { ColDef } from 'ag-grid-enterprise';
import { Clause } from '~/api/def/endpoints/obligationsEndpoint';
import { InvestorCellObligationsAg } from '~/components/ui/tables/ag/obligationsTable/InvestorCellObligationsAg';
import { ObligationCell } from '~/components/ui/tables/ag/obligationsTable/ObligationCell';

export const colDefsObligationsTable: ColDef<Clause>[] = [
  {
    field: 'title',
    headerName: 'Obligation',
    cellRenderer: ObligationCell,
    sortable: true,
    filter: true,
    type: 'w200',
    autoHeight: true,
    cellClass: 'line-height-2',
    wrapText: true,
  },
  {
    field: 'owner',
    headerName: 'Owner',
    valueFormatter: (p) => p.value?.name,
    sortable: true,
    cellClass: 'flex align-items-center justify-content-left',
    type: 'w120',
    filter: true,
  },
  {
    field: 'investor',
    headerName: 'Investor',
    // valueFormatter: (p) => p.value?.name,
    cellClass: 'flex align-items-center justify-content-left',
    cellRenderer: InvestorCellObligationsAg,
    type: 'w120',
    sortable: true,
    filter: true,
  },
  {
    field: 'fund',
    suppressHeaderMenuButton: true,
    headerName: 'Fund',
    sortable: true,
    cellClass: 'flex align-items-center justify-content-center',
    filter: true,
    type: 'w120',
    valueFormatter: (p) => p.value?.name,
  },
];
